import {h} from 'preact';
import 'jquery-file-download';
import ContextBar from "../ContextBar";
import Renderer from '../../canvas/renderer';
import store from '../../store';
import * as actions from '../../actions';

export default function MobileAppSubheader({ }) {	
	return (<div id="app-subheader" className="sub">
		<ContextBar />
	</div>);
}